export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_LIST_VIEW = 'TOGGLE_LIST_VIEW'